exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout-settings {\r\n  background-color: #fff;\r\n  border: 1px solid #eeeeee;\r\n  border-radius: 10px;\n}\n.layout-settings:hover {\r\n  -webkit-box-shadow: 0 0 15px #ccc;\r\n          box-shadow: 0 0 15px #ccc;\n}\n.form-settings {\r\n  margin: 30px 50px 0px 50px;\n}\n.form-title {\r\n  background-color: #00BFD7;\r\n  color: #fff;\r\n  font-size: 14px;\r\n  font-family: 'SF Medium';\r\n  padding: 15px;\r\n  border-radius: 10px 10px 0px 0px;\r\n  margin-bottom: 10px;\n}\n.el-form-item__label {\r\n  font-size: 14px;\r\n  font-family: 'SF Medium';\r\n  color: #000;\n}\n.alert-image{\r\nmargin-bottom: 10px;\n}", ""]);

// exports
